/**
 * PRESS fittings that need a 25 or 26 crimp ring.
 * `outlets` is the number of rings per piece. The user chooses the variant on save.
 */

export const PRESS_RING_CODES = {
	25: "701.73.45",
	26: "701.74.45",
};

/** Exact product codes that trigger the ring question, with rings per piece. */
export const PRESS_2526_FITTINGS = [
	{ code: "701.02.45", name: 'Trecere cu racord olandez 26x3/4"', outlets: 1 },
	{ code: "701.08.45", name: 'Trecere cu filet exterior 26x3/4"', outlets: 1 },
	{ code: "701.09.45", name: 'Trecere cu filet exterior 26x1"', outlets: 1 },
	{ code: "701.14.45", name: 'Trecere cu filet interior 26x3/4"', outlets: 1 },
	{ code: "701.15.45", name: 'Trecere cu filet interior 26x1"', outlets: 1 },
	{ code: "701.19.45", name: "Niplu egal 26", outlets: 2 },
	{ code: "701.22.45", name: "Niplu redus 26-16", outlets: 1 },
	{ code: "701.23.45", name: "Niplu redus 26-20", outlets: 1 },
	{ code: "701.24.45", name: "Niplu redus 32-26", outlets: 1 },
	{ code: "701.27.45", name: "Cot egal 26", outlets: 2 },
	{ code: "701.32.45", name: 'Cot trecere FI 26x3/4"', outlets: 1 },
	{ code: "701.36.45", name: 'Cot trecere FE 26x3/4"', outlets: 1 },
	{ code: "701.40.45", name: 'Cot racord cu talpa 26x3/4"', outlets: 1 },
	{ code: "701.44.45", name: "Teu egal 26", outlets: 3 },
	{ code: "701.47.45", name: "Teu redus 16-26-16", outlets: 1 },
	{ code: "701.51.45", name: "Teu redus 20-26-20", outlets: 1 },
	{ code: "701.52.45", name: "Teu redus 26-16-16", outlets: 1 },
	{ code: "701.53.45", name: "Teu redus 26-16-20", outlets: 1 },
	{ code: "701.54.45", name: "Teu redus 26-16-26", outlets: 2 },
	{ code: "701.55.45", name: "Teu redus 26-20-16", outlets: 1 },
	{ code: "701.56.45", name: "Teu redus 26-20-20", outlets: 1 },
	{ code: "701.57.45", name: "Teu redus 26-20-26", outlets: 2 },
	{ code: "701.58.45", name: "Teu redus 26-26-16", outlets: 2 },
	{ code: "701.59.45", name: "Teu redus 26-26-20", outlets: 2 },
	{ code: "701.61.45", name: "Teu redus 32-26-26", outlets: 2 },
	{ code: "701.62.45", name: "Teu redus 32-26-32", outlets: 1 },
	{ code: "701.63.45", name: "Teu redus 32-32-26", outlets: 1 },
	{ code: "701.66.45", name: 'Teu trecere FE 26x1/2"x26', outlets: 2 },
	{ code: "701.67.45", name: 'Teu trecere FE 26x3/4"x26', outlets: 2 },
	{ code: "701.70.45", name: 'Teu trecere FI 26x1/2"x26', outlets: 2 },
	{ code: "701.71.45", name: 'Teu trecere FI 26x3/4"x26', outlets: 2 },
];

const PRESS_2526_OUTLETS_BY_CODE = Object.fromEntries(
	PRESS_2526_FITTINGS.map(fitting => [fitting.code, fitting.outlets])
);

export function isPress2526FittingCode(code) {
	return Object.prototype.hasOwnProperty.call(
		PRESS_2526_OUTLETS_BY_CODE,
		String(code || "").trim()
	);
}

function productCode(product) {
	return String(product?.product_code || product?.part_no || product?.fitting || "").trim();
}

/**
 * Rings per piece for a listed PRESS fitting. Other products return 0.
 * @param {Object} product
 * @returns {number}
 */
export function press2526RingsPerUnit(product) {
	return PRESS_2526_OUTLETS_BY_CODE[productCode(product)] || 0;
}

/**
 * Total rings: for each fitting, rings-per-piece from the table times quantity.
 * 1 piece with X rings → X. 2 pieces → 2X.
 * @param {Array} products
 * @returns {number}
 */
export function totalPress2526Rings(products) {
	return (products || []).reduce((sum, product) => {
		const perUnit = press2526RingsPerUnit(product);
		const quantity = Number(product?.quantity);
		if (!perUnit || !Number.isFinite(quantity) || quantity <= 0) {
			return sum;
		}
		return sum + perUnit * quantity;
	}, 0);
}

/**
 * Stable signature of PRESS 25/26 fittings that currently have a quantity.
 * @param {Array} products
 * @returns {string}
 */
export function pressFittingSignature(products) {
	return (products || [])
		.map(product => {
			const perUnit = press2526RingsPerUnit(product);
			const quantity = Number(product?.quantity);
			if (!perUnit || !Number.isFinite(quantity) || quantity <= 0) {
				return null;
			}
			return `${productCode(product)}:${quantity}`;
		})
		.filter(Boolean)
		.sort()
		.join("|");
}
